export default "__VITE_ASSET__DtDZeOpD__"